import { render, staticRenderFns } from "./lrfooter.vue?vue&type=template&id=63b4deae&scoped=true"
import script from "./lrfooter.vue?vue&type=script&lang=js"
export * from "./lrfooter.vue?vue&type=script&lang=js"
import style0 from "./lrfooter.vue?vue&type=style&index=0&id=63b4deae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4deae",
  null
  
)

export default component.exports